export const APP_PATH = {
  // Admin-configured reject-order reasons for this center (dropdown on the
  // Reject Order dialog). Requires ?service_type=nurse
  providerRejectionReasons: "/api/v1/provider/rejection-reasons",

  // Nurse Authentication
  login: "/api/v1/nurse/login",
  refreshToken: "/api/v1/nurse/refresh-token",
  logout: "/api/v1/nurse/logout",
  validateToken: "/api/v1/auth/validate-token",

  // Password management (OTP-based forgot password + authenticated change password)
  forgotPasswordSendOtp: "/api/v1/nurse/forgot-password/send-otp",
  forgotPasswordVerifyOtp: "/api/v1/nurse/forgot-password/verify-otp",
  forgotPasswordReset: "/api/v1/nurse/forgot-password/reset",
  changePassword: "/api/v1/nurse/change-password",

  // Notifications
  getUserNotifications: "/api/v1/notification/user",
  markNotificationRead: "/api/v1/notification",
  deleteNotification: "/api/v1/notification",
  getUnreadNotificationCount: "/api/v1/notification/unread-count",
  markAllNotificationsRead: "/api/v1/notification/mark-all-read",

  // Dashboard
  nurseDashboardMetrics: "/api/v1/nurse/dashboard/metrics",
  nurseOrderQueue: "/api/v1/nurse/orders/queue",
  nurseOngoingOrders: "/api/v1/nurse/orders/ongoing",

  // Order Management
  nurseOrders: "/api/v1/nurse/orders",
  nurseFeesConfiguration: "/api/v1/nurse/orders/fees/configuration",
  // Center operating-hours slots (Morning/Afternoon/Evening buckets clipped to
  // the center's per-day operating hours) for the authenticated nurse center.
  nurseCenterSlots: "/api/v1/nurse/center-slots",
  // Follow-up Request (revisit) for a COMPLETED order:
  // POST `${nurseOrders}/:id/follow-up-request` { serviceDate, serviceTime, preferredTimeSlot, timezone }
  nurseFollowUpRequestSuffix: "/follow-up-request",

  // Global chat dock header (patient name/avatar + booking number for an appointment)
  nurseChatAppointmentHeader: "/api/v1/nurse/chat/appointment",

  // Patient details by user id (page-independent chat dock header fallback)
  getPatientDetails: "/api/v1/consultation/patient/details",
  // Lightweight chat participant lookup (name + presigned avatar by user id) —
  // used by the global ChatDock header on any screen (incl. general chats).
  chatParticipant: "/api/v1/consultation/chat/participant",

  // Public assessment flow (assigned nurse opens via public link, no auth)
  nursePublicOrder: "/api/v1/nurse/public/orders",

  // Nurse Management (technicians)
  nurseAvailable: "/api/v1/nurse/available",
  nurse: "/api/v1/nurse",

  // Services & Pricing
  nurseServices: "/api/v1/nurse/services",
  nurseServiceCategories: "/api/v1/nurse/services/categories",
  nurseServiceGroups: "/api/v1/nurse/service-groups",
  nursePackages: "/api/v1/nurse/packages",

  // Earnings & Payment
  nurseEarningsSummary: "/api/v1/nurse/earnings/summary",
  nurseEarnings: "/api/v1/nurse/earnings",

  // Profile
  nurseProfile: "/api/v1/nurse/profile",
  nurseCenterProfile: "/api/v1/nurse/center/profile",

  // Addresses
  nurseAddress: "/api/v1/nurse/address",

  // Regions catalog (governorate-level)
  regions: "/api/v1/auth/regions",

  // Media
  uploadAvatar: "/api/v1/media/upload-avatar",

  // Consultation Chat (provider <-> patient) — shared notification-service room chat
  consultationChatMessages: "/api/v1/consultation/chat/messages",
  consultationChatMarkRead: "/api/v1/consultation/chat/mark-read",
  consultationChatUnreadCount: "/api/v1/consultation/chat/unread-count",
  consultationChatRooms: "/api/v1/consultation/chat/rooms",
  consultationChatUpload: "/api/v1/consultation/chat/upload",
  consultationChatDownload: "/api/v1/consultation/chat/download",

  // Withdrawal / Settlement / Payout Account (payment-service) — generic provider endpoints
  submitSettlementRequest: "/api/v1/payment/settlements/request",
  getProviderSettlements: "/api/v1/payment/settlements",
  getSettlementDashboard: "/api/v1/payment/settlements/dashboard",
  payoutAccounts: "/api/v1/payment/payout-accounts",
  getDefaultPayoutAccount: "/api/v1/payment/payout-accounts/default",
};
